import { branch, renderNothing, flattenProp } from 'recompose'
import { locationSelector } from 'sfproxy/selectors'
import { googleAPIReadySelector } from 'map/selectors'
import { loadGoogleAPI } from 'map/actions'
import { loadOnMount } from 'shared/hoc'
import Map from 'shared/components/Map'

export default compose(
    connect(
        createStructuredSelector({
            location: locationSelector,
            apiReady: googleAPIReadySelector,
        }),
        { loadGoogleAPI }
    ),
    loadOnMount(
        'loadGoogleAPI',
        () => [],
        props => !props.apiReady
    ),
    branch(props => !props.apiReady, renderNothing),
    flattenProp('location')
)(Map)
